<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
          <div class=" formItemBox">
               <el-form-item label="道路运输从业资格证号:" prop="qualificationNum" label-width="160px" >
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.qualificationNum "></el-input>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder="" maxlength="100" v-model="searchFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="审核状态:" prop="auditStatus">
                <el-select v-model="searchFrom.auditStatus" placeholder="请选择">
                  <el-option label="待审核" :value=1></el-option>
                  <el-option label="审核通过" :value=2></el-option>
                  <el-option label="审核未通过" :value=3></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile" >
                <el-input  placeholder="" maxlength="11" v-model="searchFrom.mobile "></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="identityNo" >
                <el-input  placeholder="" maxlength="18" v-model="searchFrom.identityNo "></el-input>
              </el-form-item>

              <el-form-item label="申请时间:" prop="dateTime" >
                <el-date-picker
                  v-model="searchFrom.dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
        </div>
        <div style="margin:10px 0 0 10px;">
              <el-form-item >
                <el-button type="primary"  @click="searchFn" btnCode="000P00WB001" v-if="btnFlg[0]">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="resetForm('searchFrom')" btnCode="000P00WB002" v-if="btnFlg[1]">重置</el-button>
              </el-form-item>
              <!-- <el-form-item >
                <el-button type="primary"  @click='chezhuFn'>车主审核2.0</el-button>
              </el-form-item> -->
              <el-form-item >
                <el-button type="primary"  @click='newChezhuFn'>车主审核3.0</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="text"  @click='tiaoZhuan'>司机查验</el-button>
              </el-form-item>
              </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' class="tableComent"
       style="width: 100%" height="100%"  center border>
          <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="province"    label="操作" align="center" width="180">
          <template slot-scope="scope">
            <!-- 1显示通过/驳回 ，不是1显示记录 -->
            <div>
            <el-button type="text" size="small" @click="passClick(scope.row)" btnCode="000P00WB003" v-if="scope.row.auditStatus == '1' && btnFlg[2]">审核</el-button>
            <el-button type="text" size="small" @click="recordClick(scope.row)" btnCode="000P00WB005" v-if="scope.row.auditStatus != '1' && btnFlg[4]">记录</el-button>
            <el-button type="text" size="mini" btnCode="" v-if="scope.row.auditStatus != '1'" @click="lookFn(scope.row)">查看</el-button>
            <!-- <el-button type="text" size="small" @click="rejectClick(scope.row)" btnCode="000P00WB004" v-if="scope.row.auditStatus == '1' && btnFlg[3]">驳回</el-button> -->
          </div>
          </template>
        </el-table-column>
       <el-table-column property="auditStatus" label="审核状态" >
          <template scope="scope">
            {{[ "待审核", "审核通过", "审核驳回" ][scope.row.auditStatus-1]}}
          </template>
        </el-table-column>
        <el-table-column prop="name"    label="司机姓名"  width="100" align="center"  ></el-table-column>
        <el-table-column prop="mobile"    label="联系电话" width="120" align="center"  ></el-table-column>
        <el-table-column property="identityNo" label="身份证号"  align="center" width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="qualificationNum"    label="道路运输从业资格证号" align="center"  width="220"></el-table-column>
        <el-table-column prop="certificateNum"  label="驾驶证档案编号" align="center" width="220" show-overflow-tooltip></el-table-column>
        <!-- <el-table-column prop="ext3"  label="审核人" align="center" ></el-table-column> -->
        <el-table-column prop="auditTime"   :formatter="dateTimeFormat" label="申请时间" align="center" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,1000]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!--点击记录-->
    <el-dialog title="记录"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="recordMark"
    width="550px"
    center>
      <span>
        <el-timeline>
          <el-timeline-item  v-for="(activity, index) in activities" :key="index" :color="activities.length-1 ? '#0bbd87' : ''">
            <p>审核时间：{{activity.ext1}}</p>
            <p>审核人：{{activity.createUserName}}</p>
            <p>审核操作：{{activity.ext2}}</p>
            <p v-if="activity.auditResult">审核结果：{{activity.auditResult}}</p>
          </el-timeline-item>
        </el-timeline>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="recordMark = false"  size='mini'>取 消</el-button>
      </span>
    </el-dialog>
     <!-- 审核 -->
    <drawer :imgList="imgList"  v-if="drawerFlag"  @destroy="destroy">
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
             <el-form-item label="司机姓名:" prop="name">
                <el-input  placeholder=""  maxlength="11" v-model.trim="addFrom.name"></el-input>
              </el-form-item>
              <el-form-item label="身份证号:" prop="identityNo">
                <el-input   maxlength="18" v-model.trim="addFrom.identityNo"></el-input>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <el-input  placeholder="" maxlength="11" v-number-input.float="0" v-model="addFrom.mobile"></el-input>
              </el-form-item>
              <el-form-item label="道路运输从业资格证:" label-width="200" prop="qualificationNum">
                <el-input  placeholder=""  maxlength="50" v-model.trim="addFrom.qualificationNum"></el-input>
              </el-form-item>
              <el-form-item label="驾驶证档案号:" prop="certificateNum">
                <el-input  placeholder="" maxlength="50" v-model.trim="addFrom.certificateNum"></el-input>
              </el-form-item>
            <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>审核意见</span>
              </h4>
            </div>
            <div style="text-align: center;margin-bottom:20px">
               <el-input type="textarea" style="width: 95%;" v-model="addFrom.nopassReason" onkeyup="this.value=this.value.replace(/^ +| +$/g,'')"></el-input>
            </div>
             <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>运力信息</span>
              </h4>
            </div>
              <el-table :data="carList"  ref="table"   bordersize="mini"  height="400" style="width: 100%" center border>
                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column  type="index" width="55" label="序号"></el-table-column>
                <el-table-column prop="vhcNo"  width="120" :formatter="emptyFn" label="车牌号"></el-table-column>
                <el-table-column prop="noColourName" width="120"  :show-overflow-tooltip="true" :formatter="emptyFn" label="车牌颜色"></el-table-column>
                <el-table-column prop="vhcTypeName"  width="120" :show-overflow-tooltip="true" :formatter="emptyFn" label="车辆类型"></el-table-column>
                <el-table-column prop="drivingLicense" :formatter="emptyFn" width="200"  :show-overflow-tooltip="true" label="行驶证档案号"></el-table-column>
                <el-table-column property="vehicleTenantName" min-width="240"  :show-overflow-tooltip="true" :formatter="emptyFn" label="车辆所有人" > </el-table-column>
            </el-table>
        </div>
        </el-form>
      </span>
      <div class="footerBox">
        <el-button type="primary" @click="SHsaveFn(2)">通过</el-button>
        <el-button type="primary" @click="SHsaveFn(3)">驳回</el-button>
      </div>
    </drawer>
     <!-- 查看 -->
     <el-dialog title="查看详情" :close-on-click-modal="false" class="detailBox" :close-on-press-escape="false" :visible.sync="dialoglook" @close="closeDialogB" width="1120px" center>
      <span>
         <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline jiaoyan" label-width="150px" size="mini">
        <!-- <el-form-item label="审批人">
          <el-input  placeholder="审批人"></el-input>
        </el-form-item> -->
        <div class="inpBox">
              <div class="addressBox">
              <h4 class="title">
                <span><i class="fa fa-tags iconFont" aria-hidden="true"></i>基本信息</span>
              </h4>
            </div>
              <el-form-item label="身份证号:" prop="identityNo">
                <span>{{addFrom.identityNo}}</span>
              </el-form-item>
               <el-form-item label="司机姓名:" prop="name">
                <span>{{addFrom.name}}</span>
              </el-form-item>
              <el-form-item label="联系电话:" prop="mobile">
                <span>{{addFrom.mobile}}</span>
              </el-form-item>
               <!-- <el-form-item label="司机所属:" prop="driverClassify">
               <span> {{[ "市场司机", "自家司机" ][addFrom.driverClassify-1]}}</span>
             </el-form-item> -->
              <el-form-item label="所属单位/个人:" prop="driverTenantName">
               <span>{{addFrom.driverTenantName}}</span>
              </el-form-item>
              <el-form-item label="驾驶证号:" prop="licenseNum">
               <span>{{addFrom.licenseNum}}</span>
              </el-form-item>
               <el-form-item label="身份证有效期:" prop="identityExpiringDate">
                 <span>{{addFrom.identityExpiringDate}}</span>
                </el-form-item>
                <el-form-item label="驾驶证档案号:" prop="certificateNum">
                  <span>{{addFrom.certificateNum}}</span>
              </el-form-item>
                <el-form-item label="准驾车型:" prop="quasiDrivingModel" >
                 <span>{{addFrom.quasiDrivingModel}}</span>
                </el-form-item>
                <el-form-item label="驾驶证发证机关:" prop="issueAuthority" >
                 <span>{{addFrom.issueAuthority}}</span>
                </el-form-item>
                <el-form-item label="驾照起始日期:" prop="validPeriodFrom" >
                 <span>{{addFrom.validPeriodFrom|dateFormat1}}</span>
                </el-form-item>
                <el-form-item label="驾照截止日期:" prop="validPeriodTo">
                 <span>{{addFrom.validPeriodTo}}</span>
                </el-form-item>
              <el-form-item label="道路运输从业资格证:" label-width="200" prop="qualificationNum">
               <span style="width:560px">{{addFrom.qualificationNum}}</span>
              </el-form-item>
              <el-form-item label="行政区域:" prop="xname" >
               <span style="width:200px">{{addFrom.provinceName}}-{{addFrom.cityName}}-{{addFrom.areaName}}</span>
              </el-form-item>
              <el-form-item label="身份证地址:" label-width="200" prop="address">
               <span style="width:300px">{{addFrom.address}}</span>
              </el-form-item>
              <el-form-item label="常走路线:" prop="useLines">
               <div style="width:560px">{{addFrom.useLines}}</div>
              </el-form-item>
               <div class="box">
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto1Url"
                      :preview-src-list="[addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl]">
                    </el-image>
                    <h6 class="is-need">身份证正面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.identityPhoto2Url"
                      :preview-src-list="[addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url]">
                    </el-image>
                    <h6  class="is-need">身份证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix1Url"
                      :preview-src-list="[addFrom.appendix1Url,addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证正面</h6>
                </div>
                <div class="imgBox">
                     <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.appendix2Url"
                      :preview-src-list="[addFrom.appendix2Url,addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url]">
                    </el-image>
                    <h6  class="is-need">驾驶证背面</h6>
                </div>
                <div class="imgBox">
                      <el-image
                      style="width: 320px; height: 200px"
                      :src="addFrom.qualificationPhotoUrl"
                      :preview-src-list="[addFrom.qualificationPhotoUrl,addFrom.identityPhoto1Url,addFrom.identityPhoto2Url,addFrom.appendix1Url,addFrom.appendix2Url]">
                    </el-image>
                    <h6  class="is-need">道路运输从业资格证</h6>
                </div>
              </div>

        </div>
      </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialoglook = false">关闭</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat, dateFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  driverInfoList, // 列表查询
  dictionary, // 数据字典
  driverInfoUpdateCheckData, // 驳回/通过
  zzauditHistoryList // 记录
} from '@/api/consignment'
import { getCVehicleInfoAllByDriverId, detailDriver } from '@/api/vgs-driver2.0'
import drawer from '@/views/consignment/registerAttestation/drawer.vue'
export default {
  components: {
    drawer
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50,
        auditStatus: 1
      },
      total: 0,
      loading: 'false',
      zzauditStatusOptions: [], // 审核状态
      // 记录
      activities: [],
      recordMark: false,
      drawerFlag: false,
      addFrom: {},
      carList: [],
      imgList: [],
      rules: {
        name: [
          { required: true, message: '请输入司机姓名', trigger: 'blur' }
        ],
        identityNo: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { validator: this.rule.idCardValidity, trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        account: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          this.rule.mobile
        ],
        licenseNum: [
          { required: true, message: '请输入驾驶证号', trigger: 'blur' }
        ],
        certificateNum: [
          { required: true, message: '请输入驾驶证号档案号', trigger: 'blur' }
        ],
        qualificationNum: [
          { required: true, message: '请输入从业资格证号', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['000P00WB001', '000P00WB002', '000P00WB003',
        '000P00WB004', '000P00WB005'],
      dialoglook: false,
      FKfrom: {
        SKlist: []
      }
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/registerAttestation/driverCheck')
    // this.dictionary()
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    // 审核
    passClick (row) {
      getCVehicleInfoAllByDriverId({ driverId: row.id }).then(res => {
        this.carList = res
        this.addFrom = { ...row }
        this.$set(this.addFrom, 'nopassReason', '')
        this.drawerFlag = true
      }).catch(res => {
        console.log(res, (res))
      })
      this.imgList = []
      if (row.identityPhoto1Url != '') {
        this.imgList.push({ ImgUrl: row.identityPhoto1Url, name: '身份证正页' })
      }
      if (row.appendix1Url != '') {
        this.imgList.push({ ImgUrl: row.appendix1Url, name: '驾驶证主页' })
      }
      if (row.qualificationPhotoUrl != '') {
        this.imgList.push({ ImgUrl: row.qualificationPhotoUrl, name: '从业资格证' })
      }
      if (row.identityPhoto2Url != '') {
        this.imgList.push({ ImgUrl: row.identityPhoto2Url, name: '身份证副页' })
      }
      if (row.appendix2Url != '') {
        this.imgList.push({ ImgUrl: row.appendix2Url, name: '驾驶证副页' })
      }
    },
    destroy () {
      this.drawerFlag = false
    },
    SHsaveFn (n) {
      if (n == 3) {
        if (this.addFrom.nopassReason) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          driverInfoUpdateCheckData({
            // 驳回传3  通过传2
            nopassReason: this.addFrom.nopassReason,
            id: this.addFrom.id,
            auditStatus: '3'
          }).then(res => {
            loading.close()
            this.$message({
              message: '成功',
              type: 'success'
            })
            this.drawerFlag = false
            this.getList()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          this.$alert('请输入驳回原因', '系统提示')
        }
      } else {
        this.$refs.addFrom.validate((valid) => {
          if (valid) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            this.addFrom.auditStatus = 2
            driverInfoUpdateCheckData(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '成功',
                type: 'success'
              })
              this.drawerFlag = false
              this.getList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        })
      }
    },
    // 点击记录
    recordClick (row) {
      this.recordMark = true
      zzauditHistoryList({
        drivercarId: row.id,
        drivercarFlg: '1'
      }).then(res => {
        this.activities = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 车主审核2.0
    chezhuFn () {
      this.$router.push('/registerAttestation/captainCheck')
    },
    // 车主审核3.0
    newChezhuFn () {
      this.$router.push('/registerAttestation/newCaptainCheck')
    },
    // 跳转新页面
    tiaoZhuan () {
      window.open('http://app.gjzwfw.gov.cn/jmopen/webapp/html5/jtbdlyzry/index.html')
    },
    // 获取审核状态下拉框数据
    // dictionary () {
    //   dictionary({
    //     groupNo: 'zzaudit_status'
    //   }).then(res => {
    //     this.zzauditStatusOptions = res.zzaudit_status
    //     this.zzauditStatusOptions.forEach((item, index) => {
    //       if (item.itemNo == '1') {
    //         this.searchFrom.auditStatus = item.itemNo
    //       }
    //     })
    //   }).catch(err => {
    //     DonMessage.error(err.message)
    //   })
    // },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {

    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.dateTime) {
        this.searchFrom.startTime = this.searchFrom.dateTime[0]
        this.searchFrom.endTime = this.searchFrom.dateTime[1]
      }
      this.loading = true
      driverInfoList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
        this.$previewRefresh()
      }).catch(err => {
        this.loading = false
        DonMessage.error(err.message)
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.getList()
    },

    closeDialog () {
      this.$refs.table.clearSelection()
      this.$refs.addFrom.clearValidate()
    },
    // 查看
    lookFn (row) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      detailDriver({ driverId: row.id }).then(res => {
        loading.close()
        this.addFrom = res
        this.FKfrom.SKlist = res.cDriverBankCardList
        this.dialoglook = true
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    closeDialogB () {

    }
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.inpBox .el-date-editor{
      width: 350px!important;
}
.box{
  display: flex;
  flex-wrap: wrap;
  .imgBox{
    display: flex;
      margin-right:30px;
    flex-direction: column;
    width: 320px;
    /deep/.el-upload--picture-card{
          width: 320px;
    height: 200px;
    }
  }
  h6{
    text-align: center;
  }
  .hidden /deep/.el-upload--picture-card{
  display: none;
  }
  /deep/.el-upload--picture-card {
    background-image: url(../../../../assets/images/upload1.png);
    background-size: 320px;
  }
  /deep/.el-upload-list--picture-card .el-upload-list__item{
          width: 320px;
    height: 200px;
  }
}
</style>
